var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldandInteroperabilityTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451,24.6H47c-12.7,0-22.4,9.7-22.4,22.4v299.2c0,12.7,9.7,22.4,22.4,22.4h138.7l-40.7,95 c-0.7,2.2-0.7,4.5,0.7,6.7c1.5,1.5,3.7,3,6,3h194.5c2.2,0,4.5-1.5,6-3c1.5-1.5,1.5-4.5,0.7-6.7l-40.7-95H451 c12.7,0,22.4-9.7,22.4-22.4V47C473.4,34.3,463.7,24.6,451,24.6z M335,458.5H163l38.9-89.8h95L335,458.5z M458.5,346.2 c0,4.5-3,7.5-7.5,7.5H47c-4.5,0-7.5-3-7.5-7.5V47c0-4.5,3-7.5,7.5-7.5H451c4.5,0,7.5,3,7.5,7.5L458.5,346.2L458.5,346.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.4,440.5c1.5,1.5,3.7,3,6,3h103.2c3,0,5.2-1.5,6.7-3c1.5-1.5,1.5-4.5,0.7-6.7l-19.4-44.9 c-0.7-3-3.7-4.5-6.7-4.5h-65.1c-3,0-5.2,1.5-6.7,4.5l-19.4,44.9C189.9,436,189.9,438.3,191.4,440.5z M221.3,398.6h55.4l12.7,29.9 h-80.8L221.3,398.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.1,54.5H76.9c-12.7,0-22.4,9.7-22.4,22.4v239.4c0,12.7,9.7,22.4,22.4,22.4h344.1 c12.7,0,22.4-9.7,22.4-22.4V76.9C443.5,64.2,433.8,54.5,421.1,54.5z M428.5,316.3c0,4.5-3,7.5-7.5,7.5H76.9c-4.5,0-7.5-3-7.5-7.5 V76.9c0-4.5,3-7.5,7.5-7.5h344.1c4.5,0,7.5,3,7.5,7.5L428.5,316.3L428.5,316.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.1,84.4c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0c-0.2,0-0.3,0-0.5,0c-62.1,0-112.2,50.1-112.2,112.2 s50.1,112.2,112.2,112.2c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.2,0c0.2,0,0.5,0,0.7,0c61.4-0.8,110.8-50.6,110.8-112.2 S259.5,85.2,198.1,84.4z M293.6,189.2h-35.8c-1.4-33.3-11.8-63.9-26.4-83.4C265.8,118.9,290.7,150.9,293.6,189.2z M189.2,101.9 v87.3h-37.2C153.9,145.3,173,111.2,189.2,101.9z M189.2,204.1v87.3c-16.2-9.3-35.2-43.4-37.2-87.3L189.2,204.1L189.2,204.1z  M204.1,292.2v-88h38.7C240.8,249.3,220.6,284.2,204.1,292.2z M204.1,189.2v-88c16.5,8,36.7,42.8,38.7,88H204.1z M163.9,105 c-14.9,19.4-25.6,50.4-27,84.2H99.7C102.6,150.1,128.5,117.6,163.9,105z M99.7,204.1H137c1.4,33.7,12.1,64.8,27,84.2 C128.5,275.7,102.6,243.2,99.7,204.1z M231.4,287.5c14.6-19.4,25-50.1,26.4-83.4h35.8C290.7,242.4,265.8,274.4,231.4,287.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.9,86.7l-24.7,24.7l-9.7-9.7c-3-3-7.5-3-10.5,0c-3,3-3,7.5,0,10.5l15,15c1.5,1.5,3,2.2,5.2,2.2 s3.7-0.7,5.2-2.2l29.9-29.9c3-3,3-7.5,0-10.5C408.3,83.7,403.8,83.7,400.9,86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.9,169l-24.7,24.7l-9.7-9.7c-3-3-7.5-3-10.5,0c-3,3-3,7.5,0,10.5l15,15c1.5,1.5,3,2.2,5.2,2.2 s3.7-0.7,5.2-2.2l29.9-29.9c3-3,3-7.5,0-10.5C408.3,166,403.8,166,400.9,169z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.9,258.7l-24.7,24.7l-9.7-9.7c-3-3-7.5-3-10.5,0c-3,3-3,7.5,0,10.5l15,15c1.5,1.5,3,2.2,5.2,2.2 s3.7-0.7,5.2-2.2l29.9-29.9c3-3,3-7.5,0-10.5C408.3,255.7,403.8,255.7,400.9,258.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldandInteroperabilityTesting);
export default __webpack_public_path__ + "static/media/Field and Interoperability Testing.9879f591060701e31a08d1ff2e2755d6.svg";
export { ForwardRef as ReactComponent };